import { IconType } from "../../components/Icon";
import { Layout } from "../../components/Layout";
import { Navbar } from "../../components/Navbar";
import { NavigationTitle } from "../../components/NavigationTitle";
import { ChangeEmail } from "../../components/PagesContent/ChangeEmail";

export const ChangeEmailPage = () => {
  const topBar = (
    <NavigationTitle title="changeEmail" iconName="arrowLeft" iconType={IconType.default} />
  );
  const navBar = <Navbar />;

  return (
    <Layout topBar={topBar} navBar={navBar} includeGaps={false} fixedTop={false}>
      <ChangeEmail />
    </Layout>
  );
};
